import { Conversation } from '../models/conversation.interface';
import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import * as moment from 'moment';
export const LOAD_CHAT = 'LOAD_CHAT';
export const NEW_CHAT = 'NEW_CHAT';
export const UPDATE_CHAT_BY_ID = 'UPDATE_CHAT_BY_ID';
export const ADD_CHAT_BY_ID = 'ADD_CHAT_BY_ID';
export const UPDATE_CHAT = 'UPDATE_CHAT';
export const LOAD_CHAT_OFFSET = 'LOAD_CHAT_OFFSET';

interface LoadChatActionType {
	type: string;
	payload: Conversation[];
}

interface AddNewChatActionType {
	type: string;
	newChatToAdd: Conversation[];
}

interface UpdateChatByIdActionType {
	type: string;
	chatToUpdateById: Conversation;
}

interface UpdateChatActionType {
	type: string;
	chatToUpdate: Conversation;
}

export function loadChat(payload: Conversation[]): LoadChatActionType {
	return { type: LOAD_CHAT, payload: payload };
}

export function addNewChat(newChatToAdd: Conversation[]): AddNewChatActionType {
	return { type: NEW_CHAT, newChatToAdd };
}

export function updateChat(chatToUpdate: Conversation): UpdateChatActionType {
	return { type: UPDATE_CHAT, chatToUpdate };
}

export function updateChatById(
	chatToUpdateById: Conversation
): UpdateChatByIdActionType {
	return { type: UPDATE_CHAT_BY_ID, chatToUpdateById };
}

export function loadChatOffset(payload: any) {
	return { type: LOAD_CHAT_OFFSET, payload: payload }
}

export const onNewChatArrived = (message: any) => {
	return (dispatch: Dispatch<any>, getState: () => any) => {
		const currState = getState();
		const chat = currState.chat;
		//check if the chat belong to the user in state
		if (chat.allIds.includes(message.Chat.to_identifier)) {
			const chatExists = chat.byId[message.Chat.to_identifier].some(
				(obj: any) =>
					obj.conversation_id === message.Chat.conversation_id
			);
			if (chatExists) {
				dispatch(updateChatById(message.Chat));
			} else {
				dispatch(updateChat(message.Chat));
			}
		} else {
			// new chat
			const TO = moment.default().unix();
			const FROM = moment.default().subtract(6, "months").unix();
			networkCall(`get`, `/conversation/chat-list?to_identifier=${message.Chat.to_identifier}&limit=25&to_created_at=${TO}&from_created_at=${FROM}`, apiBaseUrl.baseUrl)
				.then((response: any) => {
					const payloadData = {
						limit: response.limit,
						total: response.total,
						page: 25,
						identifier: message.Chat.to_identifier
					}
					dispatch(loadChatOffset(payloadData));
					dispatch(loadChat(response.data));
				}).catch((error: any) => {
					console.log(error);
				});
		}
	};
};
